import { Helmet } from "react-helmet-async"
import { MailboxesTab, TMailIntegration } from "../../../../../Integrations"
import { useOutletContext } from "react-router"

export default function MailIntegrationMailboxesPage() {
	const context = useOutletContext<{ integration: TMailIntegration }>()

	return (
		<>
			<Helmet>
				<title>Mailboxes | Integration</title>
			</Helmet>
			<MailboxesTab integration={context.integration} />
		</>
	)
}
